import React from "react";
import ReactDOM from "react-dom/client";
import { registerZodPtBR } from "@opus-dt/shared-types";
import { App } from "./App";
import { loadEnv } from "./lib/env";
import { initSentry } from "./lib/sentry";
import "./styles/fonts-latin.css";
import "@opus-dt/ui-tokens/tokens.css";
import "./styles.css";

registerZodPtBR();

loadEnv();
initSentry();

const root = document.getElementById("root");
if (!root) throw new Error("#root not found in index.html");

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
